import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { DoctorService } from '../../service/apiservice/doctor.service';
import { Globals } from '../../globals';
import { User } from '../../service/modal/user';
import { Router } from '@angular/router';
import { LoginData } from '../../service/modal/login';
import { LoginService } from '../../service/apiservice/login.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
declare function info_noti(msg: any): any;
declare var $;
declare var printJS;
@Component({
  selector: 'app-doctorpage',
  templateUrl: './doctorpage.component.html',
  styleUrls: ['./doctorpage.component.css']
})
export class DoctorpageComponent implements OnInit {

  loggedUserInfo: User;
  patientGrid: User[] = new Array();
  submitted = false;
  searchForm: FormGroup;
  isLoadSearchForm = false;
  @ViewChild('addSearchForm') addSearchForm;


  healthCardData;
  healthCardPath = "";
  healthCardSinglePage;

  hcBackSideForm: FormGroup;
  isHealthCardBackSideForm = false;
  healthCardBackSidePreviewObj: any;

  multiplehealthCardBackSidePreviewObj=[];
  selectedMailList = [];
  checkClickCount = 0;
  showActions: boolean = false;

  constructor(private formBuilder: FormBuilder, private _loginService: LoginService, private doctorservice: DoctorService, private global: Globals, private router: Router, private chRef: ChangeDetectorRef, private spinner: NgxSpinnerService) {

  }

  ngOnInit() {

    localStorage.setItem("Active Route", this.router.url);
    // if (this.global.loggedUser.user.doctorStatusActive == true) {
    //    info_noti("Your Account  Deactivated ")
    //   this.router.navigate(['login']);
    //   this.global.loggedUser = new LoginData();
    //   this.global.sharehealthCard = "";
    //   this.global.switchProfileStr = "";
    //   this.global.refreshCount = 0;
    //   this.router.navigate(['login']);
    //   localStorage.clear();
    // }

    this.global.afterRefreshPageSetToken();
    // console.log(this.global.loggedUser.user);
    this.loadSearchForm();
    this.getUserInfoById();
    // this.loggedUserInfo = this.global.loggedUser.user;




  }


  getUserInfoById() {
    this._loginService.getUserById(this.global.loggedUser.user.user_reg_id).subscribe(response => {
      this.loggedUserInfo = response;
      this.GetPatient_Grid();
    }, err => { });

  }

  GetPatient_Grid() {
    this.submitted = false;
    this.addSearchForm.resetForm();
    this.doctorservice.findByUsedReferalcode(this.loggedUserInfo.userRefCode).subscribe((response) => {
      if ($.fn.dataTable.isDataTable('#patientDatatable')) {
        $('#patientDatatable').dataTable().fnClearTable();
        $('#patientDatatable').dataTable().fnDestroy();
      }
      // if ($.fn.dataTable.isDataTable('#approvedDatatable_IsMobile')) {
      //   $('#approvedDatatable_IsMobile').dataTable().fnClearTable();
      //   $('#approvedDatatable_IsMobile').dataTable().fnDestroy();
      // }

      Object.assign(this.patientGrid, response);
      this.chRef.detectChanges();
      // console.log(this.patientGrid)




      $("#patientDatatable").DataTable({
       
        "paging": false,
        "info": false,
        'columnDefs': [{ 'orderable': false, 'targets': 0 }],
        "order": [[1, 'desc']],
        // "searching": false,
        // "pageLength": 0,
        // "lengthMenu": [0, 5, 10, 20, 50, 100, 200, 500],
        dom: 'Bfrtip',
        buttons: [
          { extend: 'pdf', title: 'User List Pdf', attr: { id: "pdfBtn" }, exportOptions:  { columns: [1, 3, 6, 7, 8, 9,10,11,12,13] }  },
          { extend: 'excel', title: 'User List Excel', attr: { id: "excelBtn" }, exportOptions: { columns: [1, 3, 6, 7, 8, 9,10,11,12,13] } }
        ],
        "fnDrawCallback": function () {
          var table = $('#patientDatatable').DataTable();
          $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
          $(table.buttons('.buttons-excel').nodes()).css("display", "none");
        }
      });


      $("#patientDatatable_filter").hide();

      //   $("#approvedDatatable_IsMobile_filter").DataTable({
      //     "paging": false,
      //     "info": false,
      //     dom: 'Bfrtip',
      //     buttons: [
      //       { extend: 'pdf', title:'subjectPdf', attr: { id: "pdfBtn" } },
      //       { extend: 'excel',  title:'subjectExcel',attr: { id: "excelBtn" } }
      //     ],
      //     "fnDrawCallback": function () {
      //       var table = $('#approvedDatatable_IsMobile_filter').DataTable();
      //       $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
      //       $(table.buttons('.buttons-excel').nodes()).css("display", "none");
      //     }
      //   });
      //   $("#approvedDatatable_IsMobile_filter").hide();
      // },
      //   error => {
      //     console.log(error);
    })
  }
  ExportExcel() {
    $("#excelBtn").click();
  }

  ExportPdf() {
    debugger;
    $("#pdfBtn").click();
  }
  loadSearchForm() {
    this.isLoadSearchForm = true;
    this.searchForm = this.formBuilder.group({
      'todate': [null, Validators.required],
      'fromdate': [null, Validators.required]
    })

  }
  search() {
    debugger;
    console.log(this.searchForm);

    this.submitted = true;
    if (!this.searchForm.valid) {
      return;
    }
    this.doctorservice.searchToAndFromDate(this.searchForm.controls['todate'].value, this.searchForm.controls['fromdate'].value, this.loggedUserInfo.userRefCode).subscribe((response) => {
      if ($.fn.dataTable.isDataTable('#patientDatatable')) {
        $('#patientDatatable').dataTable().fnClearTable();
        $('#patientDatatable').dataTable().fnDestroy();
      }
      // if ($.fn.dataTable.isDataTable('#approvedDatatable_IsMobile')) {
      //   $('#approvedDatatable_IsMobile').dataTable().fnClearTable();
      //   $('#approvedDatatable_IsMobile').dataTable().fnDestroy();
      // }

      Object.assign(this.patientGrid, response);
      this.chRef.detectChanges();

      $("#patientDatatable").DataTable({
        "paging": false,
        "info": false,
        'columnDefs': [{ 'orderable': false, 'targets': 0 }],
        "order": [[1, 'desc']],
        dom: 'Bfrtip',
        buttons: [
          { extend: 'pdf', title: 'approvedPdf', attr: { id: "pdfBtn" }, exportOptions: { columns: [1, 3, 6, 7, 8, 9,10,11,12,13] } },
          { extend: 'excel', title: 'approvedExcel', attr: { id: "excelBtn" }, exportOptions: { columns: [1, 3, 6, 7, 8, 9,10,11,12,13] } }
        ],
        "fnDrawCallback": function () {
          var table = $('#patientDatatable').DataTable();
          $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
          $(table.buttons('.buttons-excel').nodes()).css("display", "none");
        }
      });


      $("#patientDatatable_filter").hide();
    }, err => {

    });

  }

  printHealthCard_DataBind(data) {
    this.spinner.show();
    // console.log("pageOnePath" + this.healthCardData)
    // this.doctorservice.createHealthCard(data.user_reg_id, 'twopage').subscribe(response => {
    //   this.spinner.hide();
    //   this.healthCardData = response;
    //   if (this.healthCardData != 'undefined') {
    //     $("#previewHealthCardDoctorModal").modal("show");
    //     // this.GetPatient_Grid();
    //   }
    // }, err => {
    //   this.spinner.hide();
    // });

    this._loginService.getUserById(data.user_reg_id).subscribe((response) => {
      debugger
      this.spinner.hide();
      this.loadHealtCardBakSideForm(response, "PrintPage");

      $("#previewORPrintHealthCardModal").modal("show");
     
    }, err => {
      this.spinner.hide();
    });






    // this.healthCardPageOne=data.healthCardPageOnePath;
    // console.log( "pageOnePath"+this.healthCardPageOne)
    // this.healthCardPageTwo=data.healthCardPageTwoPath;
    // console.log( "pageTwoPath"+this.healthCardPageTwo)

  }

  printHelathCardPageTwo(data) {
    printJS(data);

  }
  printHelathCardPageOne(data) {
    printJS(data);
  }

  clearData() {
    this.healthCardData = "";
  }


  printHealthCardForSinglePage(data) {
    this.spinner.show();
    // this.doctorservice.createHealthCard(data.user_reg_id, 'singlepage').subscribe((response) => {
    //   this.spinner.hide();
    //   this.healthCardSinglePage = response.healthcardpath;
    //   // console.log("healthcard ::::" + this.healthCardSinglePage);

    //   if (this.healthCardSinglePage != 'undefined') {
    //     $("#previewHealthCardSinglePageModal").modal("show");
    //   }

    //   // this.getUserInfoById();
    // }, err => {
    //   this.spinner.hide();
    // });

    this._loginService.getUserById(data.user_reg_id).subscribe((response) => {
      debugger
      this.spinner.hide();
      this.loadHealtCardBakSideForm(response, "SinglePage");

      // this.printModal();
      // if (this.healthCardSinglePage != 'undefined') {
      $("#previewORPrintHealthCardModal").modal("show");
      // }

      // this.getUserInfoById();
    }, err => {
      this.spinner.hide();
    });


  }
  printHelathCard() {
    printJS(this.healthCardSinglePage);
  }
  updateCampRegisterUser(data: User) {
    // console.log(data);
    this.router.navigate(['doctordashboard/updatecampregisteruser/' + data.user_reg_id]);
  }
  DeleteUser(userid) {
    this._loginService.deleteUser(userid).subscribe(res => {
      if (res === 'Deleted') {
        info_noti("User Deleted Successfully");
        this.getUserInfoById();
      } else {
        info_noti("User Not Deleted Successfully")
      }
    }, err => {

    });
  }

  printHealthCard(printStatus) {

    let printContents, popupWin;

    if (printStatus === 'SinglePage') {
      printContents = document.getElementById('singlePage').innerHTML;

    } else if (printStatus === 'FirstPage') {
      printContents = document.getElementById('printfirstpage').innerHTML;
    } else if (printStatus === 'SecondPage') {
      printContents = document.getElementById('printsecondpage').innerHTML;
    }

    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
       
          <style>
        
    /* Health Card css */
      .td{
        word-wrap:break-word; 
      }
      td.tdnormalfontwithleft{
        text-align: left;
        padding: 0px;
        font-family: 'Times New Roman';
      font-size:12px;
        }
        td.tdboldfontwithcenter{
          text-align: center;
        padding: 0px;
      font-family: 'Times New Roman';
        font-weight:bold;
      font-size:12px;
        }
        td.tdnormalfontwithcenter{
        text-align: center;
        padding: 0px;
      font-family: 'Times New Roman';
      font-size:12px;
      }

        .divsizehealthhistory{
         word-wrap:break-word; 
        width:320px;
        height:45px; 
        overflow: hidden !important;
      word-wrap:break-word; 
      }
      .divsizepolicydetails{
        width:310px;
        height:13px; 
        overflow: hidden !important;
      }
      .divsizereferaltext{
        height:12px; 
        overflow: hidden !important;
      }
      .divsizeaddress{
        width:310px;
      display: block; 
      height:28px; 
      overflow: hidden !important;
        }
      .divsizehealthcardbackside{
      width:305px;
      display: block; 
      height:71px; 
      overflow: hidden !important;
    }
    p.healthcardparagraph{
      margin-bottom: 0px;
    }
    .lefttable{
      table-layout: fixed;
     width: 320px;
      height: 204px;
     border: 1px
      word-wrap:break-word; 
    }

    .maintable{
      table-layout: fixed;
      width: 640px;
      height: 204px;
    }

    .qrcode{
      text-align: left;
    }
    .emergencyDetailsCenter{ 
      text-align:center; 
      padding: 0px;
      font-family: 'Times New Roman';
      font-size:12px;
    } 
    //   table.bordertable{
    //    border: 1px solid black;
    //  }

    p{margin:0; padding:0}
    td{margin:0; padding:0}

    .watermarkhealthcardimage
    {
      width: 100px;
      height: 100px;
  
    background:url('../../../assets/images/watermark.png');
    background-repeat:no-repeat;
    background-position:center;
    }
    
    .watermarkhealthcard{
      width: 320px;
      height: 203px;
      table-layout: fixed;
    }

        @page {
          size:8.3in 11.7in; 
          margin: 0.35in .5in .5in 1.21in; 
          // margin: 32.94fin 9in 0in  86.41in; 
          mso-header-margin: .5in; 
          mso-footer-margin: .5in; 
          mso-paper-source: 0;
     }
     
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  printHealthCardOnSinglePage() {

    let printContents, popupWin;
    printContents = document.getElementById('singlePage').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
       
          <style>
        
    /* Health Card css */
      .td{
        word-wrap:break-word; 
      }
      td.tdnormalfontwithleft{
      
        text-align: left;
        padding: 0px;
        font-family: 'Times New Roman';
      font-size:12px;
        }
        td.tdboldfontwithcenter{
          text-align: center;
        padding: 0px;
      font-family: 'Times New Roman';
        font-weight:bold;
      font-size:12px;
        }
        td.tdnormalfontwithcenter{
        text-align: center;
        padding: 0px;
      font-family: 'Times New Roman';
      font-size:12px;
      }


        .divsizehealthhistory{
         word-wrap:break-word; 
        width:320px;
        height:45px; 
        overflow: hidden !important;
      word-wrap:break-word; 
      }

      .divsizepolicydetails{
        width:320px;
        height:13px; 
        overflow: hidden !important;
      }
      .divsizereferaltext{
        height:11px; 
        overflow: hidden !important;
      }
      .divsizeaddress{
        width:320px;
      display: block; 
      height:28px; 
      overflow: hidden !important;
        }

      .divsizehealthcardbackside{
      width:320px;
      display: block; 
      height:71px; 
      overflow: hidden !important;
    }
    p.healthcardparagraph{
      margin-bottom: 0px;
    }

    .lefttable{
     width: 330px;
      height: 204px;
     border: 1px
      word-wrap:break-word; 
    }

    .maintable{
      table-layout: fixed;
      width: 660px;
      height: 204px;
    }

    table.bordertable{
     border: 1px solid black;
   }
   .qrcode{
    text-align: left;
   }
    p{margin:0; padding:0}
    td{margin:0; padding:0}

    .emergencyDetailsCenter{ 
      text-align:center; 
    
      padding: 0px;
      font-family: 'Times New Roman';
      font-size:12px;
    } 
    .watermarkhealthcardimage
   {
    width: 100px;
    height: 99px;
     background:url('../../../assets/images/watermark.png');
   background-repeat:no-repeat;
    background-position:center;
    }
  
    .watermarkhealthcard{
     width: 330px;
      height: 200px;
    // opacity:0.6;
    // filter:alpha(opacity=60);
     }
        @page {
          size:8.3in 11.7in;  
          margin: .0in .5in .5in 0.5in; 
          mso-header-margin: .5in; 
          mso-footer-margin: .5in; 
          mso-paper-source: 0;
     }
     
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  loadHealtCardBakSideForm(reponse, printStatus) {
    debugger;
    this.isHealthCardBackSideForm = true;
    var postaladdress = "";
    if (reponse.address != null) {

      if (reponse.postalAddress != null) {

        var addarr = reponse.postalAddress.split("-");
        var addarr1 = addarr[1].split(",");
        var addarr2 = addarr1[1].split("[");

        postaladdress = reponse.address + " " + addarr1[0] + ", " + addarr1[1] + " " + addarr[0] + ", " + addarr2[0].substring(0, 1) + addarr2[0].substring(1, addarr2[0].length).toLowerCase() + ", India";
      } else {
        postaladdress = reponse.pinCode + ", India";
      }
    } else {

      if (reponse.postalAddress != null) {

        var addarr = reponse.postalAddress.split("-");
        var addarr1 = addarr[1].split(",");
        var addarr2 = addarr1[1].split("[");

        postaladdress = addarr1[0] + ", " + addarr1[1] + " " + addarr[0] + ", " + addarr2[0].substring(0, 1) + addarr2[0].substring(1, addarr2[0].length).toLowerCase() + ", India";
      } else {
        postaladdress = reponse.pinCode + ", India";
      }

    }


    var healthhistory = "";
    var other = "";

    if (reponse.healthHistory != null) {
      if (reponse.healthHistory !== "") {

        var historyarr = reponse.healthHistory.split(",");

        for (var i = 0; i < historyarr.length; i++) {
          if (historyarr[i] === "Other") {
            other = reponse.other;
          } else if (historyarr[i] === "") {

          } else {
            healthhistory = healthhistory + historyarr[i] + ", ";
          }
        }
      }
    }
    healthhistory = healthhistory + other;


    this.hcBackSideForm = this.formBuilder.group({
      'pageprint': [printStatus],
      'profileImgPath': [reponse.profileImgPath],
      'mdhlId': [reponse.emailAddress],
      'firstName': [reponse.firstName],
      'lastName': [reponse.lastName],
      'dob': [reponse.dob],
      'mobileNo': [reponse.mobileNumber],
      'gender': [reponse.gender],
      'bloodGroup': [reponse.bloodGroup],
      // 'pinCode': [reponse.pinCode],
      'address': [postaladdress],
      // 'postalAddress':[reponse.postalAddress],
      // 'otherHealthHistory': [reponse.other],
      'healthHistory': [healthhistory],
      'policyDetails': [reponse.policyDetails],
      'emergencyName': [reponse.emergencyName],
      'emergencyContactNo': [reponse.emergencyConatctNo],

      'scanqrcode': ['Scan QR Code'],
      'qrcodelogo': ['https://mdhl.s3.ap-south-1.amazonaws.com/mdhlQrCode.png'],
      'or': ['OR'],
      'visit': ['Visit app.mdhl.in'],
      'issuedby': ['Health Card issued by'],
      'poweredby': [' EasyReach Healthcare Private Limited'],
      'callus': ['Call Us:+918433513351 (Mon-Fri):10.00 AM-06.00 PM (IST)'],
      'hcRefferalText': [reponse.healthCardIssueText],
      'hcBackSideText': [reponse.healthCardBackSideText],

    })

    this.healthCardBackSidePreviewObj = this.hcBackSideForm.value;
    console.log(this.healthCardBackSidePreviewObj);

  }

  previewHealthCardBakSideClearData() {
    $("#previewORPrintHealthCardModal").modal("hide");
    this.healthCardBackSidePreviewObj = null;
  }


  multiplePrint(){
    this.spinner.show();
    console.log(this.selectedMailList);
    this._loginService.findMultipleUserById(this.selectedMailList).subscribe(res=>{
     this.multipleloadHealtCardBakSideForm(res);
      this.isHealthCardBackSideForm = false;
      this.spinner.hide();
      $("#MultiplePreviewORPrintHealthCardModal").modal("show");
      // this.GetPatient_Grid();
    },err=>{
    });
  }
  multiplePreviewHealthCardClearData() {
    $("#MultiplePreviewORPrintHealthCardModal").modal("hide");
    this.multiplehealthCardBackSidePreviewObj = [];
  }



  multipleloadHealtCardBakSideForm(reponse) {
    debugger;
    this.isHealthCardBackSideForm = true;
    // console.log(reponse)
    var count=1;
    for(var j=0;j<reponse.length;j++){
    
        var userInfo=reponse[j];

    var postaladdress = "";
    if (userInfo.address != null) {
      if(userInfo.address != ""){
      if (userInfo.postalAddress != null) {
        var addarr = userInfo.postalAddress.split("-");
        var addarr1 = addarr[1].split(",");
        var addarr2 = addarr1[1].split("[");

        postaladdress = userInfo.address + " " + addarr1[0] + ", " + addarr1[1] + " " + addarr[0] + ", " + addarr2[0].substring(0, 1) + addarr2[0].substring(1, addarr2[0].length).toLowerCase() + ", India";
      } else {
        postaladdress =userInfo.pinCode + ", India";
      }
    }else {

      if (userInfo.postalAddress != null) {

        var addarr = userInfo.postalAddress.split("-");
        var addarr1 = addarr[1].split(",");
        var addarr2 = addarr1[1].split("[");

        postaladdress = addarr1[0] + ", " + addarr1[1] + " " + addarr[0] + ", " + addarr2[0].substring(0, 1) + addarr2[0].substring(1, addarr2[0].length).toLowerCase() + ", India";
      } else {
        postaladdress = userInfo.pinCode + ", India";
      }
    }
    } else {

      if (userInfo.postalAddress != null) {

        var addarr = userInfo.postalAddress.split("-");
        var addarr1 = addarr[1].split(",");
        var addarr2 = addarr1[1].split("[");

        postaladdress = addarr1[0] + ", " + addarr1[1] + " " + addarr[0] + ", " + addarr2[0].substring(0, 1) + addarr2[0].substring(1, addarr2[0].length).toLowerCase() + ", India";
      } else {
        postaladdress = userInfo.pinCode + ", India";
      }

    }


    var healthhistory = "";
    var other = "";

    if (userInfo.healthHistory != null) {
      if (userInfo.healthHistory !== "") {

        var historyarr = userInfo.healthHistory.split(",");

        for (var i = 0; i < historyarr.length; i++) {
          if (historyarr[i] === "Other") {
            other = userInfo.other;
          } else if (historyarr[i] === "") {

          } else {
            healthhistory = healthhistory + historyarr[i] + ", ";
          }
        }
      }
    }
    healthhistory = healthhistory + other;
    var breakhealthcard=false;
    if(count%5==0){
       breakhealthcard=true;
    }
    count++;
    var healthCardRecord={
      'profileImgPath': userInfo.profileImgPath,
      'mdhlId':userInfo.emailAddress,
      'firstName': userInfo.firstName,
      'lastName': userInfo.lastName,
      'dob': userInfo.dob,
      'mobileNo': userInfo.mobileNumber,
      'gender': userInfo.gender,
      'bloodGroup': userInfo.bloodGroup,
      'address': postaladdress,
      'healthHistory': healthhistory,
      'policyDetails': userInfo.policyDetails,
      'emergencyName': userInfo.emergencyName,
      'emergencyContactNo': userInfo.emergencyConatctNo,
      'scanqrcode': 'Scan QR Code',
      'qrcodelogo': 'https://mdhl.s3.ap-south-1.amazonaws.com/mdhlQrCode.png',
      'or': 'OR',
      'visit':'Visit app.mdhl.in',
      'issuedby': 'Health Card issued by',
      'poweredby': ' EasyReach Healthcare Private Limited',
      'callus': 'Call Us:+918433513351 (Mon-Fri):10.00 AM-06.00 PM (IST)',
      'hcRefferalText': userInfo.healthCardIssueText,
      'hcBackSideText': userInfo.healthCardBackSideText,
      'break':breakhealthcard
    }

    // this.healthCardBackSidePreviewObj = this.hcBackSideForm.value;
    // console.log(this.healthCardBackSidePreviewObj);
    // console.log("i value"+j);
    this.multiplehealthCardBackSidePreviewObj.push(healthCardRecord);
   }
   console.log(this.multiplehealthCardBackSidePreviewObj);
  }


  checkboxChanged(event, obj, status, allSelectedList, type) {
    debugger;

    if (status == "selectAll") {
      if (event.target.checked) {
        var i = 1;
        var rows = $("#patientDatatable").dataTable()._('tr', {"filter":"applied"});
        console.log(rows);
        console.log(rows.length);
        console.log("rows print");  


        for(let i=0;i<rows.length;i++){
        console.log(); 
        let row=rows[i];
        this.selectedMailList.push(row[1]);
        let checkboxid=row[2];
        $('#checkbox' + checkboxid).prop("checked", true);
         }

        console.log(this.selectedMailList);
        // allSelectedList.forEach(element => {
        //   this.selectedMailList.push(element.user_reg_id);
        //   $('#checkbox' + i).prop("checked", true);
        //   i++;
        // })

      } else {

        var i = 1;

        allSelectedList.forEach(element => {
          this.selectedMailList.splice(this.selectedMailList.indexOf(element.user_reg_id, 1));
          $('#checkbox' + i).prop("checked", false);
          i++;
        })
      }
      console.log(this.selectedMailList);
    } else {

      if (event.target.checked) {
        this.selectedMailList.push(obj.user_reg_id);

        var rows = $("#patientDatatable").dataTable()._('tr', {"filter":"applied"});
        console.log(rows.length);
        if (this.selectedMailList.length ==rows.length) {
          $('#selectAll').prop("checked", true);
        }
        console.log(this.selectedMailList);
      }
      else {
        $('#selectAll').prop("checked", false);
        this.selectedMailList.splice(this.selectedMailList.indexOf(obj.user_reg_id), 1);
        console.log(this.selectedMailList);
      }
    }
    this.selectedMailList = Array.from(new Set(this.selectedMailList));

    if (this.selectedMailList.length > 0) {
      this.showActions = true;
      if (this.checkClickCount == 0) {
        this.checkClickCount = 1;

      }
    }
    else {
      this.checkClickCount = 0;
      this.showActions = false;
    }
  }


}



